export const getTokenTransfers = (
  dispatch: any,
  token: string,
  dateRange: any[],
  querySize: number,
  maxResults: number,
  context: string
) =>
  dispatch({
    type: "GET_TOKENTRANSFERS",
    token,
    dateRange,
    querySize,
    maxResults,
    context,
  });

export const getTokenTransfersSuccess = (
  transfers: any[],
  token: string,
  dateRange: any[],
  total: number,
  rangeTotal: number,
  context: string
) => ({
  type: "GET_TOKENTRANSFERS_SUCCESS",
  transfers,
  token,
  dateRange,
  total,
  rangeTotal,
  context,
});

export const getTokenTransfersFailure = (error: Error) => ({
  type: "GET_TOKENTRANSFERS_FAILURE",
  error,
});

export const clearTokenTransfers = (dispatch: any) =>
  dispatch({ type: "CLEAR_TOKENTRANSFERS" });
